const $ = require("jquery");
require("slick-carousel-latest");
const { map, max } = lodash;

$(window).on("load", () => {
  const activeClassName = "bs-active";
  const focusedClassName = "bs-focused";
  const visibilityClassName = "bs-visibility-hidden";
  const defaultBreakpoint = 576;

  const initSlick = () => {
    if ($(".bs-slider-accordion [data-slick]").length) {
      $(".bs-slider-accordion [data-slick]").not(".slick-initialized").slick();
    }
  };

  $(".bs-slider-accordion-slick").each((i, accordion_element) => {
    const accordionId = $(accordion_element).attr("id");
    const fadeIn = $(accordion_element).data("fadein");
    if (fadeIn) {
      $(
        `#${accordionId}_container .bs-slider-accordion__floating-panel-container .bs-slider-accordion__floating-panel`
      )
        .children()
        .fadeOut();
      $(
        `#${accordionId}_container .bs-slider-accordion__floating-panel-container .bs-slider-accordion__floating-panel.show`
      )
        .children()
        .fadeIn(800);
    }

    $(`#${accordionId}_container .bs-slider-accordion-slick`).on(
      "afterChange",
      function (event, slick, currentSlide) {
        const target = $(`#${accordionId} .slick-current`)
          .find(".accordion__block__btn")
          .data("target");
        const floatingPanel = $(
          `#${accordionId}_container .bs-slider-accordion__floating-panel[data-parent='${target}']`
        );

        if (!$(slick.$slides[currentSlide]).hasClass(focusedClassName)) {
          //add active class to current slick active item
          $(`#${accordionId} .card`).removeClass(activeClassName);
          $(`#${accordionId} .slick-current .card`).addClass(activeClassName);

          //add show class to active block btn
          $(`#${accordionId} .card div`).removeClass("show");
          $(`#${accordionId} .slick-current ${target}`).addClass("show");
        }

        //Removing focused class from all the slides after the transition
        $(slick.$slides).removeClass(focusedClassName);

        //add show class to folting panel
        if (target && floatingPanel) {
          //add fadeIn fadeOut option to folating panel when after change the slider and add show class to current target floating panel
          floatingPanel.siblings().removeClass("show");
          floatingPanel.addClass("show");
          if (fadeIn) {
            floatingPanel.siblings().children().fadeOut();
            floatingPanel.children().fadeIn(800);
          }
        }
      }
    );
  });

  const toggleActiveTab = (btn, fadeIn) => {
    if (btn.parents(".slick-slide").siblings().length) {
      //toggle active class in card element when slick slider is enable
      $(btn.parents(".slick-slide").siblings()).each((index, element) => {
        $(element).find(".card").removeClass(activeClassName);
      });
      btn.parent().addClass(activeClassName);
    } else {
      //add fadeIn fadeOut option in mobile view
      if (fadeIn) {
        btn
          .parent()
          .siblings(".card")
          .find(".bs-slider-accordion__floating-panel")
          .children()
          .fadeOut(1);
        btn
          .parent()
          .find(".bs-slider-accordion__floating-panel")
          .children()
          .fadeIn(800);
      }
      //toggle active class in card element
      btn.parent().siblings(".card").removeClass(activeClassName);
      btn.parent().toggleClass(activeClassName);
    }
  };

  const applybreakPointStyle = () => {
    $(".bs-slider-accordion").each((i, accordion_element) => {
      const accordion = $(accordion_element);
      const breakpointWidth =
        accordion.data("attributes")?.breakpoint || defaultBreakpoint;
      const defaultOpenIndex =
        accordion.data("attributes")?.defaultOpenIndex || 0;

      const cardCollection = accordion.find(".card .collapse");

      const floatingPanelContainer = accordion.find(
        ".bs-slider-accordion__floating-panel-container"
      );

      cardCollection.find(".card-body").height("");
      floatingPanelContainer.height("");

      if ($(window).width() < breakpointWidth) {
        accordion
          .find(":not(.bs-slider-accordion-slick)[id^='accordion']")
          .css("display", "block");

        //remove floating-panel item from floating-panel-container and add inside the card item
        accordion
          .find(".bs-slider-accordion__floating-panel ")
          .each((i, panel) => {
            const $panel = $(panel);
            $panel.removeClass(visibilityClassName);
            $($panel.data("parent")).append(panel);
          });
      } else {
        accordion
          .find(":not(.bs-slider-accordion-slick)[id^='accordion']")
          .css("display", "flex");
        //remove floating-panel item from card  and restore in to the floating-panel-container
        const floatingPanels = accordion.find(
          ".bs-slider-accordion__floating-panel"
        );

        const floatingPanelsContainerLength = accordion.find(
          ".bs-slider-accordion__floating-panel-container .bs-slider-accordion__floating-panel"
        ).length;

        floatingPanels.each((i, panel) => {
          if ($(panel).parents(".slick-slide:not(.slick-cloned)").length) {
            accordion
              .find(".bs-slider-accordion__floating-panel-container")
              .append(panel);
          } else if (floatingPanelsContainerLength == 0) {
            if (accordion.find(".bs-slider-accordion-slick").length) {
              $(panel).remove();
            } else {
              accordion
                .find(".bs-slider-accordion__floating-panel-container")
                .append(panel);
            }
          }
        });

        const getHeight = (panel, i, changeClass) => {
          panel.addClass(changeClass);
          const height = panel.height();
          if (i !== defaultOpenIndex) {
            panel.removeClass(changeClass);
          }
          return height;
        };

        let floatingPanelMaxHeight = max(
          map(
            floatingPanelContainer.find(".bs-slider-accordion__floating-panel"),
            (contentPanel, i) => {
              return getHeight($(contentPanel), i, "show");
            }
          )
        );

        const cardMaxHeight = max(
          map(cardCollection, (card, i) => {
            return getHeight($(card), i, "bs-active");
          })
        );

        cardCollection.find(".card-body").height(cardMaxHeight);
        floatingPanelContainer.height(floatingPanelMaxHeight);
        floatingPanelContainer
          .find(".bs-slider-accordion__floating-panel")
          .removeClass(visibilityClassName);
      }
    });
  };

  const addAndRemoveClasses = () => {
    $(".bs-slider-accordion").each((index, accordion) => {
      const $accordion = $(accordion);
      const fadeIn = $(accordion).find(".bs-slider-accordion-slick").data("fadein");
      const target = $accordion
        .find(".bs-slider-accordion__floating-panel.show")
        .data("parent");

      const targetAccordionBlockBtnNotCloned = $accordion.find(
        `.slick-list .slick-slide:not(.slick-cloned) .accordion__block__btn[data-target='${target}']`
      );

      const targetAccordionBlockBtnCloned = $accordion.find(
        `.slick-list .slick-slide.slick-cloned .accordion__block__btn[data-target='${target}']`
      );

      const cardItem = targetAccordionBlockBtnNotCloned.length
        ? targetAccordionBlockBtnNotCloned.parent()
        : $accordion
            .find(`.accordion__block__btn[data-target='${target}']`)
            .parent();

      $accordion.find(".card").not(cardItem).removeClass(activeClassName);
      if (targetAccordionBlockBtnCloned.length) {
        targetAccordionBlockBtnCloned
          .siblings(".card-panel")
          .removeClass("show");
      }

      //accordion block btn click action
      $accordion
        .find(".accordion__block__btn")
        .off("click")
        .on("click", (e) => {
          const button = $(e.target);
          const slickSlider = $($accordion).find(
            ".bs-slider-accordion-slick.slick-initialized"
          );
          const slickObject = slickSlider.slick("getSlick");
          const focusOnSelect =
            slickObject.options && slickObject.options.focusOnSelect
              ? slickObject.options.focusOnSelect
              : false;
          // If focus on select is enabled, setting a class on button click
          if (focusOnSelect) {
            $(slickObject.$slides).removeClass(focusedClassName);
            $(button).closest(".slick-slide").addClass(focusedClassName);
          }

          toggleActiveTab(button, fadeIn);
          const target = button.data("target");

          const leftContentPanel = $(
            `.bs-slider-accordion__floating-panel[data-parent='${target}']`
          );

          if (target && leftContentPanel) {
            $accordion
              .find(`.bs-slider-accordion__floating-panel`)
              .removeClass("show");
            leftContentPanel.addClass("show");
          }
        });
    });
  };

  const autoPlaySpeedFunction = () => {
    $(".bs-slider-accordion--progress-bar [data-slick]").each((index, ele) => {
      if ($(ele).hasClass("slick-initialized")) {
        const slick = $(ele).slick("getSlick");
        //Appending the animator span to each slick slide element
        $.each($(ele).find(".slick-slide .card"), (i, element) => {
          if ($(element).find(".slick-slide-animator").length === 0) {
            $(element).append('<span class="slick-slide-animator"></span>');
          }
        });
        //set animator animation-duration
        if (slick.options.autoplay === true) {
          const playSpeed = slick.options.autoplaySpeed;
          $(ele)
            .find(".slick-slide-animator")
            .attr("data-speed", `${playSpeed}ms`)
            .css("animation-duration", `${playSpeed}ms`);
        }
      } else {
        // Removing the elements when the slider is not activated
        $.each($(ele).find(".card"), (i, element) => {
          $(element).find(".slick-slide-animator").remove();
        });
      }
    });
  };

  // handle resize event
  const handleResize = () => {
    initSlick();
    autoPlaySpeedFunction();
    applybreakPointStyle();
    addAndRemoveClasses();
  };

  $(window).on("resize", debounce(handleResize, 500));

  initSlick();
  autoPlaySpeedFunction();
  applybreakPointStyle();
  addAndRemoveClasses();
});
